<template>
  <div>
    <slot name="header" />
    <div v-if="isFetchingUserExperience">
      <v-skeleton-loader v-for="i in 3" :key="i" type="list-item-avatar" />
    </div>
    <div v-else>
      <ExperienceListItem
        v-for="experience in sortedUserExperience"
        :experience="experience"
        :key="experience.id"
      />
      <span v-if="isListEmpty">
        <ExperienceListItem :experience="{}" isPlaceholder />
      </span>
    </div>
    <v-divider v-if="showDivider" />
  </div>
</template>

<script>
import ExperienceListItem from "@/components/workers/experience/ExperienceListItem";
import { EXPERIENCE_NAMESPACE } from "@/store/modules/users/experience";
import { createNamespacedHelpers } from "vuex";
import { copyState } from "@/utils/helpers";
import {
  FETCH_USER_EXPERIENCE,
  FETCH_USER_BOOKING_EXPERIENCE
} from "@/store/modules/users/experience/actions";
import { orderBy, isEmpty } from "lodash";

const { mapActions, mapState } = createNamespacedHelpers(EXPERIENCE_NAMESPACE);

export default {
  name: "ExperienceList",
  components: { ExperienceListItem },
  created() {
    this.bookingId
      ? this.fetchBookingExperience({
          userId: this.userId,
          bookingId: this.bookingId
        })
      : this.fetchExperience(this.userId);
  },
  props: {
    userId: {
      type: String,
      required: true
    },
    showDivider: Boolean,
    bookingId: String
  },
  computed: {
    ...mapState(
      copyState(["isFetchingUserExperience", "currentUserExperience"])
    ),
    sortedUserExperience() {
      return orderBy(this.currentUserExperience, "endDate", "desc");
    },
    isListEmpty() {
      return isEmpty(this.currentUserExperience);
    }
  },
  methods: {
    ...mapActions({
      fetchExperience: FETCH_USER_EXPERIENCE,
      fetchBookingExperience: FETCH_USER_BOOKING_EXPERIENCE
    })
  }
};
</script>
